import React from "react";
import { Provider } from "../interfaces/intefaces";

interface IProps {
  providers: Provider[]
  selectedProviders: number[]
  removeFilter: (pr: number) => void

}

const FiltersSelected: React.FC<IProps> = ({ providers, selectedProviders, removeFilter }) => {
  const filtered = providers.filter(option => (selectedProviders.includes(option.id)));

  return (
    <>
      {filtered && filtered.map((provider) => {
        return <div key={`filter-selected-${provider.id}`} className="provider" onClick={() => removeFilter(provider.id)}>
            <span className="provider-title">{provider.name}</span>
        </div>
      })}
    </>
  );
}

export default FiltersSelected;